import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import {
  PhnSubscriptionPlanInterface,
  setEditId,
  setEditError,
  selectPhnSubscriptionPlanById
} from "src/store/callrecorder/phnSubscriptionPlansSlice";
import {
  updatePhnSubscriptionPlan,
  fetchPhnSubscriptionPlan
} from "src/actions/callrecorder/phnSubscriptionPlansActions";

import DrawerRight from "src/componets/DrawerRight";
import Form from './_partials/_Form';
import AlertBlock from "src/componets/AlertBlock";

const Edit = () => {
  const dispatch = useAppDispatch();
  const id: any = useAppSelector(state => state.callrecorder.phnSubscriptionPlans.editId);
  const error   = useAppSelector(state => state.callrecorder.phnSubscriptionPlans.editError);
  const plan    = useAppSelector(state => selectPhnSubscriptionPlanById(state, id));

  useEffect(() => {
    if (id) {
      dispatch(fetchPhnSubscriptionPlan(id));
    }
  }, [id, dispatch]);

  function onCloseError() {
    dispatch(setEditError(null));
  }

  function onClose() {
    dispatch(setEditId(null));
  }

  function onFinish(data: PhnSubscriptionPlanInterface) {
    handleSave(data).catch(console.error);
  }

  async function handleSave(data: PhnSubscriptionPlanInterface) {
    const resultAction = await dispatch(updatePhnSubscriptionPlan({ id, data }));

    if (updatePhnSubscriptionPlan.fulfilled.match(resultAction)) {
      onClose();
    }
  }

  return (
    <DrawerRight
      open={!!id}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-edit-phn-subscription-plan'>
        <h6 className="v-content-label">Edit Plan</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form params={plan} onFinish={onFinish} />
      </div>
    </DrawerRight>
  )
}

export default Edit;
